import * as React from "react";
import PropTypes from 'prop-types';

const SvgInfoSmall = props => {
  if (props.id !== "_svginfosmall") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12 2.4A9.6 9.6 0 002.4 12a9.6 9.6 0 009.6 9.6 9.6 9.6 0 009.6-9.6A9.6 9.6 0 0012 2.4zm-1.371 15.085h2.742V10.63H10.63v6.856zM12 9.257a1.37 1.37 0 110-2.742 1.37 1.37 0 010 2.742z" fill="#0077C5" /></svg>;
};

SvgInfoSmall.displayName = "_svginfosmall";
SvgInfoSmall.propTypes = {
  id: PropTypes.string
};
SvgInfoSmall.defaultProps = {
  id: ''
};
export default SvgInfoSmall;